module.exports = __webpack_public_path__ + "media/images/miscellaneous_icons/clock-icon-9028fb26eec31046ae7cbe77e815172f.png";